export const BOOKING_STATUS = {
  ACTIVE: 'active',
  PENDING: 'pending',
  CANCELLED: 'cancelled',
  RESCHEDULED: 'rescheduled',
} as const;

export type BookingStatus = typeof BOOKING_STATUS[keyof typeof BOOKING_STATUS];

export const BOOKING_STATUS_LABEL: Record<BookingStatus, string> = {
  [BOOKING_STATUS.ACTIVE]: 'Active',
  [BOOKING_STATUS.PENDING]: 'Pending',
  [BOOKING_STATUS.CANCELLED]: 'Cancelled',
  [BOOKING_STATUS.RESCHEDULED]: 'Rescheduled',
};

export const BOOKING_STATUS_OPTIONS = Object.values(BOOKING_STATUS);

export const BOOKING_TYPE = {
  ADVANCE: 'advance',
  WALK_IN: 'walkin',
} as const;

export type BookingType = typeof BOOKING_TYPE[keyof typeof BOOKING_TYPE];

export const BOOKING_TYPE_LABEL: Record<BookingType, string> = {
  [BOOKING_TYPE.ADVANCE]: 'Advance',
  [BOOKING_TYPE.WALK_IN]: 'Walk-in',
};

export const BOOKING_TYPE_OPTIONS = Object.values(BOOKING_TYPE);

export const STATUS_COLORS: Record<BookingStatus, 'success' | 'warning' | 'error' | 'info'> = {
  [BOOKING_STATUS.ACTIVE]: 'success',
  [BOOKING_STATUS.PENDING]: 'warning',
  [BOOKING_STATUS.CANCELLED]: 'error',
  [BOOKING_STATUS.RESCHEDULED]: 'info',
};

export const STATUS_NOTIFICATION_LABEL = {
  [BOOKING_STATUS.CANCELLED]: 'Cancellation',
  [BOOKING_STATUS.RESCHEDULED]: 'Reschedule',
} as const;

export const AUDIT_SKIP_FIELDS = [
  'dayBookings',
  'BOOKINGID',
  'CREATEDON',
  'LASTMODIFIEDON',
] as const;

export const AUDIT_FIELD_KEY = {
  ROOM_ALLOCATION_SUMMARY: 'ROOM_ALLOCATION_SUMMARY',
  DRIVER_AMOUNT_PER_DAY_SUMMARY: 'DRIVER_AMOUNT_PER_DAY_SUMMARY',
  AMOUNT_PER_PERSON_SUMMARY: 'AMOUNT_PER_PERSON_SUMMARY',
  STAY_DAY_ALLOCATION_SUMMARY: 'STAY_DAY_ALLOCATION_SUMMARY',
} as const;

export const AUDIT_SUMMARY_FIELDS = [
  AUDIT_FIELD_KEY.ROOM_ALLOCATION_SUMMARY,
  AUDIT_FIELD_KEY.DRIVER_AMOUNT_PER_DAY_SUMMARY,
  AUDIT_FIELD_KEY.AMOUNT_PER_PERSON_SUMMARY,
  AUDIT_FIELD_KEY.STAY_DAY_ALLOCATION_SUMMARY,
] as const;

export const AUDIT_FIELD_LABEL: Record<string, string> = {
  GUEST_NAME: 'Guest Name',
  PHONE: 'Phone',
  EMAIL: 'Email',
  ADDRESS: 'Address',
  CHECKIN_DATE: 'Check-in',
  CHECKOUT_DATE: 'Check-out',
  BOOKING_TYPE: 'Booking Type',
  NO_ADULTS: 'Adults',
  NO_CHILDREN: 'Children',
  NO_DRIVERS: 'Drivers',
  ADVANCE_AMOUNT: 'Advance (₹)',
  TOTAL_AMOUNT: 'Total (₹)',
  SYSTEM_CALCULATED_TOTAL: 'System Calculated Total (₹)',
  AMOUNT_DIFFERENCE: 'Amount Difference (₹)',
  AMOUNT_OVERRIDE_REASON: 'Amount Override Reason',
  AMOUNT_OVERRIDE_NOTE: 'Amount Override Note',
  BOOKED_BY: 'Booked By',
  REMARKS: 'Remarks',
  STATUS: 'Status',
  CANCELLED_ON: 'Cancelled On',
  RESCHEDULED_ON: 'Rescheduled On',
  CREATEDBY: 'Created By',
  LASTMODIFIEDBY: 'Modified By',
  ROOM_ALLOCATION_SUMMARY: 'Room Allocation',
  DRIVER_AMOUNT_PER_DAY_SUMMARY: 'Driver Amount/Day',
  AMOUNT_PER_PERSON_SUMMARY: 'Amount/Person',
  STAY_DAY_ALLOCATION_SUMMARY: 'Stay Day Allocation',
  to: 'Sent To',
  guest: 'Guest',
  status: 'Status',
  withPdf: 'PDF Attached',
  systemCalculatedAmount: 'System Calculated (₹)',
  enteredAmount: 'Entered Amount (₹)',
  difference: 'Difference (₹)',
  reason: 'Reason',
  note: 'Note',
};
